document.addEventListener('DOMContentLoaded', () => {
    const config = {
        method: 'POST',
        cache: 'no-cache',
        headers: {'Content-Type': 'application/json'},
    };
    document.getElementById('rbb-advent-atc').disabled = true;
    let failed = 0;
    document.querySelectorAll('.advent-option').forEach((el) => {
        if (!el.value) {
            failed++;
        }
        el.addEventListener('change', () => {
            let failed = 0;
            document.querySelectorAll('.advent-option').forEach((opt) => {
                if (!opt.value) {
                    failed++;
                }
            });
            document.getElementById('rbb-advent-atc').disabled = failed > 0;
        });
    });
    document.getElementById('rbb-advent-atc').disabled = failed > 0;

    document.getElementById('rbb-advent-atc').addEventListener('click', (evt) => {
        evt.target.classList.add('btn--loading');
        const items = [];
        const adventProduct = evt.target.dataset.pid;
        items.push({id: adventProduct, quantity: 1});
        document.querySelectorAll('.advent-option').forEach((opt) => {
            items.push({id: opt.value, quantity: 1});
        });
        fetch('/cart/clear.js', {
            ...config
        }).then(()=> {
            fetch('/cart/add.js', {
                ...config,
                body: JSON.stringify({
                    'items': items,
                }),
            }).then((response) => response.json()).then(() => {
                evt.target.classList.remove('btn--loading');
                window.location = theme.routes.cartPage;
            });
        });
    });

});